import React, { useState, useEffect } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import Select from "react-select";

// components
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    getBranchId,
    getTodayDate,
    getType,
    isAdmin,
    refreshPage,
    selectDropdownStyle,
    toastStyle,
    TokenExpiry,
} from "../../../Helpers/Utils/Common";
// import { searchDepartment } from './../../../Helpers/apiCalls/departmentApi';
// css
import "./PurchaseRequest.css";
// import CloseBillModal from "./Components/CloseBillModal"
import Moment from "moment";
// import { getAllBranches } from './../../../Helpers/apiCalls/Manage/Branches';
import DeleteModal from "../../../Components/Modals/DeleteModal";
import { deletePurchaseRequest, getPurchaseRequest } from "../../../Helpers/apiCalls/Purchases/purchaseRequestApi";
import { getDepartment } from "../../../Helpers/apiCalls/departmentApi";
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

/**
 *  Purchase Invoice component
 */
export default function PurchaseInvoices() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [isClicked, setIsClicked] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [bill, setBill] = useState([]);
    const [allData, setAllData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState("");

    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const [PIID, setPIID] = useState("");

    /* Close bill Modal */
    const [showCloseBillModal, setShowCloseBillModal] = useState(false);
    const handleShowCloseBillModal = () => setShowCloseBillModal(true);
    const handleCloseCloseBillModal = () => setShowCloseBillModal(false);
    const today = new Date();
    const aweekago = new Date();
    aweekago.setDate(aweekago.getDate() - 7);

    /* FILTER CONFIGS */
    const [filterConfig, setFilterConfig] = useState({
        supplier: "",
        date_from: "",
        date_to: "",
        invoice_no: "",
        type: "",
        department_id: "",
        tab: "pending",
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1,
    });

    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };


    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        if (name === "supplier") {
            var id = value.split("|")[0];
            var type = value.split("|")[1];
            var by = value.split("|")[2];
            if (by === "supplier") {
                setFilterConfig((prev) => {
                    return {
                        ...prev,
                        "supplier": id,
                        "supplier_id": id,
                        "vendor_id": "",
                        "type": type,
                    };
                });
            } else {
                setFilterConfig((prev) => {
                    return {
                        ...prev,
                        "supplier": "",
                        "supplier_id": "",
                        "vendor_id": id,
                        "type": type,
                    };
                });
            }
        } else {
            setFilterConfig((prev) => {
                return {
                    ...prev,
                    [name]: value,
                };
            });
        }
    };

    const handleTabSelect = (tabKey) => {
        setCurrentPage(1)
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                date_from: tabKey === "generated" ? aweekago :  "",
                date_to: tabKey === "generated" ? today :  "",
                page: "1",
            };
        });
    };

    async function fetchData() {
        setAllData([])
        setTotalItems(0)
        setShowLoader(true);
        const response = await getPurchaseRequest(filterConfig);

        if (response.data) {

            var allBills = response.data?.data?.map((bill) => {
                var info = bill;
                info.request_date = Moment(bill.request_date).format("MMM DD, YYYY")
                return info;
            });
            setAllData(allBills)
            setTotalItems(response.data.size);
        }
        setShowLoader(false);
    }

    async function fetchDepartment() {
        setDepartments([]);
        const response = await getDepartment({});
        if(response.data) {
            var data = response.data?.data?.map((data) => {
                var info = data;
                info.for = "department_id";
                info.select_value = "department_id_value";
                info.label = data.name;
                info.value = data.id;
                return info
            })
            setDepartments([{label: "All Department", value: ""}, ...data]);
        }
    }

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    useEffect(() => {
        fetchDepartment();
    }, []);


    function handleSupplierChange(e){
        setSelectedSupplier(e.name)
        const toFilter = {target: {name: "supplier", value: e.value}};
        handleFilterChange(toFilter);
    }

    // async function fetchBranches() {

    //     const response = await getAllBranches();
    //     if (response.error) {
    //     } else {
    //         var allBranches = response.data.data.data
    //         .filter((data) => { return data.is_franchise !== "3"})
    //         .map((data) => {
    //             var branch = data;
    //             branch.label = data.name
    //             branch.value = data.id
    //             return branch;
    //         });
    //         setBranches([{label: "All Branches", value:""}, ...allBranches]);
    //     }
    // }

    async function handleDeletePurchaseRequest() {
        setIsClicked(true)
        const response = await deletePurchaseRequest(PIID.id);
        if (response.data) {
            toast.success("Purchase Request Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            TokenExpiry(response);
            toast.error("Error Deleting Purchase Request", {
                style: toastStyle(),
            });
            setIsClicked(false)
        }
    }

    function handleSelectChange(e, id, row) {
        setBill(row)
        if (e.target.value === "edit-action") {
            navigate("/purchaserequest/edit/" + id);
        } else if (e.target.value === "view-action") {
            navigate(
                "/purchaserequest/review/" + id
            );
        } else if (e.target.value === "delete-action") {
            setPIID({ id: id });
            handleShowDeleteModal();
        } else if (e.target.value === "close-action") {
            handleShowCloseBillModal();
        } else if (e.target.value === "create-action") {
            navigate("generate/" + id)
        } else if (e.target.value === "print-action") {
            navigate("print/" + id)
        }
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={(e) => handleSelectChange(e, row.id, row)}
                value="view-action"
            >
                {
                    filterConfig.tab === "submitted" ? "Review" : "View"
                }
            </button>
        );
    }

    function EditBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={(e) => handleSelectChange(e, row.id, row)}
                value="edit-action"
            >
                Edit
            </button>
        );
    }

    
    function handleViewRow(row) {
        navigate("/purchaserequest/review/" + row.id);
    }

    function CreatePOBtn(row) {
        return (
            (accountType === "admin" || accountType === "purchasing_officer") && (
                <div>
                    <button
                        name="action"
                        className="btn btn-sm view-btn-table"
                        id={row.id}
                        onClick={(e) => handleSelectChange(e, row.id, row)}
                        value="create-action"
                    >
                        Create PO
                    </button>
                </div>
            )
        );
    }

    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row.id, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                {type === "open" &&
                (accountType === "admin" ||
                    accountType === "purchase_officer") ? (
                    <option value="edit-action" className="color-options">
                        Edit
                    </option>
                ) : null}
                <option value="view-action" className="color-options">
                    View
                </option>
                {filterConfig.tab === "approved" && (
                    <option value="print-action" className="color-options">
                        Print
                    </option>
                )}
                {(isAdmin() && (filterConfig.tab === "pending" || filterConfig.tab === "submitted")) && (
                    <option value="delete-action" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    // React.useEffect(() => {
    //     fetchBranches();
    // }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PURCHASES"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> PURCHASE REQUISITION </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="id"
                            placeholder="Search pr no..."
                            className="search-bar"
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                            <button
                                className="add-btn"
                                onClick={() => navigate("/purchaserequest/add")}
                            >
                                Add
                            </button>
                        </div>
                    </Col>
                </Row>

                <Tabs
                    activeKey={filterConfig.tab}
                    defaultActiveKey={filterConfig.tab}
                    id="PO-tabs"
                    onSelect={handleTabSelect}
                >
                    <Tab eventKey="pending" title="pending">
                        {/* filters */}
                        <div className="mb-3" />
                        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                            Filter By:
                        </span>
                        <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                            <Select
                                className="dropsearch-filter"
                                classNamePrefix="react-select"
                                placeholder="Select Department"
                                styles={selectDropdownStyle}
                                value={filterConfig.department_id_value}
                                options={departments}
                                onChange={(e) => { setFilterConfig((prev) => {
                                        return { 
                                            ...prev, 
                                            "department_id": e.value,
                                            "department_id_value": {
                                                label: e.label,
                                                value: e.value
                                            }
                                        };
                                    });}}
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_from}
                                placeholderText={"Select Date"}
                                name="date_from"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                fixedHeight
                                className="date-filter me-4 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_to}
                                placeholderText={"Select Date"}
                                name="date_to"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                minDate={filterConfig.date_from}
                                className="date-filter ps-label-content me-5 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                        </Row>
                        <div className="mb-2" />

                        <TableWithDynamicPagination
                            tableHeaders={[
                                "-",
                                "PR NO.",
                                "REQUEST DATE",
                                "DEPARTMENT",
                                "BRANCH",
                                "REQUESTED BY",
                                "PREPARED BY",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "id",
                                "request_date",
                                "department_name",
                                "branch",
                                "requested_by_name",
                                "added_by_name",
                            ]}
                            tableData={allData}
                            ActionBtn={(row) => ActionBtn(row, "pending")}
                            ViewBtn={(row) => EditBtn(row)}
                            // onRowClickedFunction={(row) => handleViewRow(row)}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="submitted" title="submitted">
                        {/* filters */}
                        <div className="mb-3" />
                        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                            Filter By:
                        </span>
                        <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                            <Select
                                className="dropsearch-filter"
                                classNamePrefix="react-select"
                                placeholder="Select Department"
                                styles={selectDropdownStyle}
                                value={filterConfig.department_id_value}
                                options={departments}
                                onChange={(e) => { setFilterConfig((prev) => {
                                        return { 
                                            ...prev, 
                                            "department_id": e.value,
                                            "department_id_value": {
                                                label: e.label,
                                                value: e.value
                                            }
                                        };
                                    });}}
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_from}
                                placeholderText={"Select Date"}
                                name="date_from"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                fixedHeight
                                className="date-filter me-4 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_to}
                                placeholderText={"Select Date"}
                                name="date_to"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                minDate={filterConfig.date_from}
                                className="date-filter ps-label-content me-5 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                        </Row>
                        <div className="mb-2" />

                        <TableWithDynamicPagination
                            tableHeaders={[
                                "-",
                                "PR NO.",
                                "REQUEST DATE",
                                "DEPARTMENT",
                                "BRANCH",
                                "REQUESTED BY",
                                "PREPARED BY",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "id",
                                "request_date",
                                "department_name",
                                "branch",
                                "requested_by_name",
                                "added_by_name",
                            ]}
                            tableData={allData}
                            ActionBtn={(row) => ActionBtn(row, "submitted")}
                            ViewBtn={(row) => ViewBtn(row)}
                            // onRowClickedFunction={(row) => handleViewRow(row)}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="approved" title="approved">
                        {/* filters */}
                        <div className="mb-3" />
                        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                            Filter By:
                        </span>
                        <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                            <Select
                                className="dropsearch-filter"
                                classNamePrefix="react-select"
                                placeholder="Select Department"
                                styles={selectDropdownStyle}
                                value={filterConfig.department_id_value}
                                options={departments}
                                onChange={(e) => { setFilterConfig((prev) => {
                                        return { 
                                            ...prev, 
                                            "department_id": e.value,
                                            "department_id_value": {
                                                label: e.label,
                                                value: e.value
                                            }
                                        };
                                    });}}
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_from}
                                placeholderText={"Select Date"}
                                name="date_from"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                fixedHeight
                                className="date-filter me-4 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_to}
                                placeholderText={"Select Date"}
                                name="date_to"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                minDate={filterConfig.date_from}
                                className="date-filter ps-label-content me-5 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                        </Row>
                        <div className="mb-2" />

                        {/* <div className=" PO-filters d-flex justify-content-center">
                            <span className="me-4 ml-4 mt-2 ps-label">
                                Grand Total: {numberFormat(grandTotal)}
                            </span>

                            <span className="me-4 ml-4 mt-2 ps-label">
                                Total Paid Amount: {numberFormat(totalPaidAmount)}
                            </span>

                            <span className="me-4 ml-4 mt-2 ps-label">
                                Total Balance: {numberFormat(totalBalance)}
                            </span>
                        </div> */}

                        <TableWithDynamicPagination
                            tableHeaders={[
                                "/",
                                "+",
                                "PR NO.",
                                "REQUEST DATE",
                                "DEPARTMENT",
                                "BRANCH",
                                "REQUESTED BY",
                                "PREPARED BY",
                                "APPROVED BY",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "/",
                                "+",
                                "id",
                                "request_date",
                                "department_name",
                                "branch",
                                "requested_by_name",
                                "added_by_name",
                                "approved_by_name",
                            ]}
                            tableData={allData}
                            ActionBtn={(row) => ActionBtn(row, "approved")}
                            PaymentBtn={(row) => CreatePOBtn(row)}
                            DoneBtn={(row) => ViewBtn(row)}
                            // onRowClickedFunction={(row) => handleViewRow(row)}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                        <div className="mb-2" />
                    </Tab>

                    <Tab eventKey="generated" title="po generated">
                        {/* filters */}
                        <div className="mb-3" />
                        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                            Filter By:
                        </span>
                        <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                            <Select
                                className="dropsearch-filter"
                                classNamePrefix="react-select"
                                placeholder="Select Department"
                                styles={selectDropdownStyle}
                                value={filterConfig.department_id_value}
                                options={departments}
                                onChange={(e) => { setFilterConfig((prev) => {
                                        return { 
                                            ...prev, 
                                            "department_id": e.value,
                                            "department_id_value": {
                                                label: e.label,
                                                value: e.value
                                            }
                                        };
                                    });}}
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_from}
                                placeholderText={"Select Date"}
                                name="date_from"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                fixedHeight
                                className="date-filter me-4 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_to}
                                placeholderText={"Select Date"}
                                name="date_to"
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                minDate={filterConfig.date_from}
                                className="date-filter ps-label-content me-5 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                            </Col>
                        </Row>
                        <div className="mb-2" />

                        <TableWithDynamicPagination
                            tableHeaders={[
                                "-",
                                "PR NO.",
                                "PO NO.",
                                "REQUEST DATE",
                                "PURCHASE DATE",
                                "DEPARTMENT",
                                "BRANCH",
                                "NOTED BY",
                                "REQUESTED BY",
                                "PREPARED BY",
                                // "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "id",
                                "po_id",
                                "request_date",
                                "purchase_date",
                                "department_name",
                                "branch",
                                "noted_by",
                                "requested_by_name",
                                "added_by_name"
                            ]}
                            tableData={allData}
                            ActionBtn={(row) => ActionBtn(row, "generated")}
                            ViewBtn={(row) => ViewBtn(row)}
                            // onRowClickedFunction={(row) => handleViewRow(row)}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                        <div className="mb-2" />
                    </Tab>
                </Tabs>
            </div>
            <DeleteModal
                show={showDeleteModal}
                onHide={() => handleCloseDeleteModal()}
                text="purchase request"
                isClicked={isClicked}
                onDelete={() => handleDeletePurchaseRequest()}
            />
            {/* <AddModal show={showAddModal} hide={handleCloseAddModal} /> */}
            {/* <CloseBillModal
                show={showCloseBillModal}
                hide={handleCloseCloseBillModal}
                type="close"
                selectedRow={bill}
                page={"view"}
            /> */}
            <Footer/>
        </div>
    );
}